import ApiClient, { type ResponseType } from '@/helpers/ApiClient';
import axiosInstance from '@/helpers/HTTPClient';

class ConversationUsersApi extends ApiClient {
  constructor() {
    super('conversations/users');
  }

  public deleteWithBody<R = ResponseType>(body: Record<string, any>, resource: string = ''): Promise<R> {
    const handledResource: string = resource && `/${resource}`;
    return axiosInstance.delete<any, R>(`${this.url}${handledResource}`, {
      data: body,
    });
  }

  public deletionCheck<R = ResponseType>(id: string | number): Promise<R> {
    return axiosInstance.get<any, R>(`${this.url}/${id}/deletion-check`);
  }
}

export default new ConversationUsersApi();
